import { useEffect, useState } from "react"
import { useParams } from "react-router-dom";

import Sidebar from "../../components/Sidebar"
import AdminHome from "./AdminHome";
import ProfileAdmin from "./ProfileAdmin";
import ReportAdmin from "./ReportAdmin";
import AssessmentAdmin from "./AssessmentAdmin";

import { Box, Container, Drawer, Grid, IconButton, useMediaQuery, useTheme } from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu";
import UsersAdmin from "./UsersAdmin";
import EmailTemplatesAdmin from "./EmailTemplatesAdmin";
import CompletedReportsAdmin from "./CompletedReportsAdmin";
import AssessmentCopyAdmin from "./AssessmentCopyAdmin";
import AdminUserResponses from "./AdminUserResponses";

const DRAWER_WIDTH = 240;

const Dashboard = ({active}) => {

    const {slugAssessment} = useParams();
    const [location, setLocation] = useState();
    const [subItem, setSubItem] = useState();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        if(active === "assessment"){
            setSubItem(slugAssessment);
        }else{
            setSubItem(undefined);
        }
        setLocation(active);
    }, [active,slugAssessment]);

    useEffect(() => {
        if (isDesktop) setDrawerOpen(false);
    }, [isDesktop, location, subItem]);

    const sidebar = <Sidebar location={location} subItem={subItem}/>;

    return (
    <Container maxWidth={false} sx={{padding:"0px!important"}}>
        <Grid container sx={{height:"calc(100vh - 84px)"}}>
            {isDesktop ? (
                <Grid size={2}>
                    {sidebar}
                </Grid>
            ) : (
                <Drawer
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                    sx={{ "& .MuiDrawer-paper": { width: DRAWER_WIDTH, boxSizing: "border-box" } }}
                >
                    <Box onClick={() => setDrawerOpen(false)} sx={{ height: "100%" }}>
                        {sidebar}
                    </Box>
                </Drawer>
            )}
            <Grid size={isDesktop ? 10 : 12} sx={{ minWidth: 0 }}>
                <Container maxWidth={"xl"} sx={{ padding: { xs: "16px", sm: "24px", md: "50px" } }}>
                    {!isDesktop && (
                        <IconButton
                            aria-label="open navigation"
                            onClick={() => setDrawerOpen(true)}
                            sx={{ mb: 2, color: "primary.main" }}
                        >
                            <MenuIcon />
                        </IconButton>
                    )}
                    {
                        location === "home" && <AdminHome/>
                    }
                    {
                        location === "profile" && <ProfileAdmin/>
                    }
                    {
                        location === "report" && <ReportAdmin/>
                    }
                    {
                        location === "assessment" && <AssessmentAdmin/>
                    }
                    {
                        location === "users" && <UsersAdmin/>
                    }
                    {
                        location === "email_templates" && <EmailTemplatesAdmin/>
                    }
                    {
                        location === "completed_reports" && <CompletedReportsAdmin/>
                    }
                    {
                        location === "assessment_copy" && <AssessmentCopyAdmin/>
                    }
                    {
                        location === "user_responses" && <AdminUserResponses/>
                    }
                </Container>
            </Grid>
        </Grid>
    </Container>
    )
}

export default Dashboard
